import { Button } from '@mui/material'
import React, { useCallback } from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useNavigate, useParams } from 'react-router-dom'
import { BannerCloseTypes, BannerKey } from 'src/Libs/banners/types'
import { Banner } from 'src/Components/banner'
import { useNewRelic } from '@e3dc-react/shell/Libs/observability-tool'
import { useUserSettings } from 'src/Hooks'
import useStyles from './styles'
import { Ai360ExtensionsLogo } from '../../../resources'

const Ai360TariffsBanner: React.FC = () => {
  const { classes } = useStyles({ xlBackgroundOffsetY: -82, lgBackgroundOffsetY: -72 })
  const { t } = useCustomTranslation()
  const { installationId, storageId } = useParams<{ installationId: string; storageId: string }>()
  const navigate = useNavigate()
  const { userSettings } = useUserSettings()
  const { pageActions } = useNewRelic()

  const redirectToInstallationExtensions = useCallback(() => {
    pageActions.componentClicked({
      componentName: 'Ai360TariffsBanner',
      userId: userSettings.userid?.toString(),
    })
    navigate(`/installation-extensions/${installationId}/${storageId}`)
  }, [pageActions, userSettings.userid, navigate, installationId, storageId])

  return (
    <Banner
      bannerKey={BannerKey.Ai360TariffsBanner}
      button={
        <Button className={classes.infoButton} onClick={redirectToInstallationExtensions}>
          {t('installation-extension.banner.ai360.complete-now')}
        </Button>
      }
      i18nKey="installation-extension.banner.ai360.text"
      textStyle={classes.text}
      containerStyle={classes.containerStyle}
      closeType={BannerCloseTypes.permanentOrTemporary}
      closeActionStyle={classes.closeActionStyle}
      icon={<Ai360ExtensionsLogo />}
    />
  )
}

export default Ai360TariffsBanner
